if (!customElements.get('form-toggle')) {
  class FormToggle extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent('form-popup:toggle'));
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('form-toggle', FormToggle);
}
